import React from 'react';
import ApproachSection from '../components/sections/ApproachSection';

const ApproachPage = () => {
  return (
    <div className="pt-20">
      <ApproachSection />
    </div>
  );
};

export default ApproachPage;